/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { uploadTaxExemptApi, UploadTaxExemptParameter } from "@eisinc/App/Services/UploadTaxExemptService";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface UploadTaxExemptHandlerParameter {
    formData: any;
    onSuccess?: (error: string) => void;
    onError?: (error: string) => void;
}

type HandlerType = ApiHandlerDiscreteParameter<
    UploadTaxExemptHandlerParameter,
    UploadTaxExemptParameter,
    ServiceResult<any>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const UploadTaxExemptCall: HandlerType = async props => {
    props.apiResult = await uploadTaxExemptApi(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult.result!);
    }
};

export const chain = [PopulateApiParameter, UploadTaxExemptCall, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const uploadTaxExempt = createHandlerChainRunner(chain, "uploadTaxExempt");
export default uploadTaxExempt;
